var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.score.name))]),_c('td',[_vm._v(_vm._s(_vm.score.score))])])}
var staticRenderFns = []

export { render, staticRenderFns }